import {
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
  QUALITATIVE_REPORT_LEVELS,
} from "../../../../constants/app-constant";
import { REPORT_CATEGORIES } from "../../../../constants/app-constant";
// import { ShareOfVoice } from "./ShareOfVoice";
import {
  Journalist,
  Sentiments,
  ShareOfVoice,
  ThematicAnalysis,
  KeywordCloud,
  Geo,
  Spokesperson,
  Publication,
} from "./";

const {
  ENTITY,
  CITY,
  JOURNALIST,
  KEYWORD,
  PUBLICATION,
  VISIBILITY,
  PROFILING,
  TOPIC,
  HEADLINE,
  PROMINANCE,
  KEY_MESSAGE,
  RECOMMENDATIOM,
  PHOTO,
  SPOKESPERSON,
} = QUALITATIVE_REPORT_LEVELS;
const { V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE, V_SOCIAL, V_BLOG } = VERTICALS;

export const publicationPrintGenreFilterList = [
  { label: "Mainlines", value: "Mainlines" },
  { label: "Financial", value: "Financial" },
  { label: "Periodical", value: "Periodical" },
  { label: "Regional", value: "Regional" },
];
export const publicationOnlineGenreFilterList = [
  { label: "Online", value: "Online" },
];
//put all the filter options in the lists below
//SOV filters
//SOV//Entity Level
export const sovEntityRankingFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.SOVEntityRankingNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVEntityRankingIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVEntityRankingWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVEntityRankingCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVEntityRankingMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVEntityRankingReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const sovEntityTrendFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.SOVEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sovEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVEntityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVEntityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVEntityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//SOV//Journalist Level
const sovJournalistRankingFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVJournalistRankingNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVJournalistRankingIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVJournalistRankingWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVJournalistRankingCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVJournalistRankingMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVJournalistRankingReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const sovJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sovJournalistTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVJournalistTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVJournalistTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVJournalistTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVJournalistTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVJournalistTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVJournalistTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//SOV//City Level
const sovCityRankingFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVCityRankingNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVCityRankingIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVCityRankingWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVCityRankingCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVCityRankingMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVCityRankingReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const sovCityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVCityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVCityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVCityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVCityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVCityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVCityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sovCityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVCityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVCityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVCityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVCityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVCityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVCityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//SOV//Keyword Level
const sovKeywordRankingFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVKeywordRankingNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVKeywordRankingIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVKeywordRankingWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVKeywordRankingCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVKeywordRankingMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVKeywordRankingReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const sovKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVKeywordTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sovKeywordTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVKeywordTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVKeywordTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVKeywordTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVKeywordTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVKeywordTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVKeywordTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//SOV//Publication Level
const sovPublicationRankingFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVPublicationRankingNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVPublicationRankingIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVPublicationRankingWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVPublicationRankingCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVPublicationRankingMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVPublicationRankingReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const sovPublicationTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVPublicationTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVPublicationTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVPublicationTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVPublicationTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVPublicationTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVPublicationTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sovPublicationTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SOVPublicationTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SOVPublicationTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SOVPublicationTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SOVPublicationTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SOVPublicationTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SOVPublicationTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//thematic// entity
const thematicEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const thematicEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const thematicEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicEntityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicEntityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicEntityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//thematic//Journalist Level
const thematicJournalistSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicJournalistSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicJournalistSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicJournalistSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicJournalistSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicJournalistSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicJournalistSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const thematicJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const thematicJournalistTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicJournalistTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicJournalistTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicJournalistTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicJournalistTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicJournalistTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicJournalistTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//thematic//City Level
const thematicCitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicCitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicCitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicCitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicCitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicCitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicCitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const thematicCityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicCityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicCityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicCityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicCityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicCityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicCityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const thematicCityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicCityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicCityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicCityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicCityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicCityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicCityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//thematic//Keyword Level
const thematicKeywordSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicKeywordSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicKeywordSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicKeywordSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicKeywordSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicKeywordSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicKeywordSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const thematicKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicKeywordTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const thematicKeywordTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicKeywordTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicKeywordTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicKeywordTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicKeywordTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicKeywordTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicKeywordTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//thematic//Publication Level
const thematicPublicationSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicPublicationSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicPublicationSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicPublicationSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicPublicationSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicPublicationSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicPublicationSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const thematicPublicationTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicPublicationTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicPublicationTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicPublicationTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicPublicationTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicPublicationTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicPublicationTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const thematicPublicationTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicPublicationTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicPublicationTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicPublicationTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicPublicationTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicPublicationTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicPublicationTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//geolocation// entity
const geolocationEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationEntitySOVWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationEntitySOVCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationEntitySOVMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const geolocationEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationEntityTrendWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationEntityTrendCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationEntityTrendMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const geolocationEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationEntityTonalityWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationEntityTonalityCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationEntityTonalityMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//geolocation//Publication Level
const geolocationPublicationSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationPublicationSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationPublicationSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationPublicationSOVWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationPublicationSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationPublicationSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationPublicationSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const geolocationPublicationTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationPublicationTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationPublicationTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationPublicationTrendWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationPublicationTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationPublicationTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationPublicationTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const geolocationPublicationTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationPublicationTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationPublicationTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationPublicationTonalityWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationPublicationTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationPublicationTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationPublicationTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//geolocation//Keyword Level
const geolocationKeywordSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationKeywordSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationKeywordSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationKeywordSOVWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationKeywordSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationKeywordSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationKeywordSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const geolocationKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationKeywordTrendWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const geolocationKeywordTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationKeywordTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationKeywordTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.GeolocationKeywordTonalityWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationKeywordTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationKeywordTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationKeywordTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//publication// entity
const publicationEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationEntitySOVCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationEntitySOVMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const publicationEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationEntityTrendCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationEntityTrendMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const publicationEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationEntityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationEntityTonalityCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationEntityTonalityMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//publication//Journalist Level
const publicationJournalistSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationJournalistSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationJournalistSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationJournalistSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationJournalistSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationJournalistSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationJournalistSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const publicationJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const publicationJournalistTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationJournalistTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationJournalistTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationJournalistTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationJournalistTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationJournalistTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationJournalistTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//publication//Keyword Level
const publicationKeywordSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationKeywordSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationKeywordSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationKeywordSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationKeywordSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationKeywordSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationKeywordSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const publicationKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationKeywordTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const publicationKeywordTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationKeywordTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationKeywordTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationKeywordTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationKeywordTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationKeywordTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationKeywordTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment filters
const sentimentTrendFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sentimentSOVFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//keyword filters
const keywordSOVFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const keywordTrendFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const keywordTonalityFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//journalist filters
const journalistSOVFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const journalistRankingFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const journalistTrendFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const journalistTonalityFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//spokesperson filters
const spokespersonSOVFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const spokespersonTrendFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//visibility filters
const visibilitySOVFilter = [

  {
    label: "Number of article",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: "Report Types",//REPORT_TYPES.SOVReportIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: "Report Types",//REPORT_TYPES.JournalistWCTrend,
    vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: "Report Types",//REPORT_TYPES.JournalistCCMTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: "Report Types",//REPORT_TYPES.JournalistMAVTrend,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: "Report Types",//REPORT_TYPES.SOVReportArticle,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//put all the filter options in the lists above


export const sentimentTableFilter = [
  {
    label: "Number of article",
    value: REPORT_TYPES.SENTIMENTTABLEARTICLE,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SENTIMENTTABLEINDEX,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

export const sovTableFilter = [
  {
    label: "Snapshot",
    value: REPORT_TYPES.SNAPSHOT,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  }
];

export const sovStoryTableFilter = [
  {
    label: "StoryTable",
    value: REPORT_TYPES.STORYTABLE,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  }
];

//new framework takes object as filterOption in widget lists.
//these are the new objects passed into filteroptions for respective widget lists
const sovEntityFilterObj = {
  Ranking: sovEntityRankingFilter,
  Trend: sovEntityTrendFilter,
  Tonality: sovEntityTonalityFilter,
}

const sovJournalistFilterObj = {
  Ranking: sovJournalistRankingFilter,
  Trend: sovJournalistTrendFilter,
  Tonality: sovJournalistTonalityFilter,
}

const sovCityFilterObj = {
  Ranking: sovCityRankingFilter,
  Trend: sovCityTrendFilter,
  Tonality: sovCityTonalityFilter,
}

const sovPublicationFilterObj = {
  Ranking: sovPublicationRankingFilter,
  Trend: sovPublicationTrendFilter,
  Tonality: sovPublicationTonalityFilter,
}

const sovKeywordFilterObj = {
  Ranking: sovKeywordRankingFilter,
  Trend: sovKeywordTrendFilter,
  Tonality: sovKeywordTonalityFilter,
}
//thematic filter objects
const thematicEntityFilterObj = {
  SOV: thematicEntitySOVFilter,
  Trend: thematicEntityTrendFilter,
  Tonality: thematicEntityTonalityFilter,
}

const thematicJournalistFilterObj = {
  SOV: thematicJournalistSOVFilter,
  Trend: thematicJournalistTrendFilter,
  Tonality: thematicJournalistTonalityFilter,
}

const thematicCityFilterObj = {
  SOV: thematicCitySOVFilter,
  Trend: thematicCityTrendFilter,
  Tonality: thematicCityTonalityFilter,
}

const thematicPublicationFilterObj = {
  SOV: thematicPublicationSOVFilter,
  Trend: thematicPublicationTrendFilter,
  Tonality: thematicPublicationTonalityFilter,
}

const thematicKeywordFilterObj = {
  SOV: thematicKeywordSOVFilter,
  Trend: thematicKeywordTrendFilter,
  Tonality: thematicKeywordTonalityFilter,
}

const sentimentFilterObj = {
  Trend: sentimentTrendFilter,
  SOV: sentimentSOVFilter,
}
const keywordFilterObj = {
  SOV: keywordSOVFilter,
  Trend: keywordTrendFilter,
  Tonality: keywordTonalityFilter,
}

const geolocationEntityFilterObj = {
  SOV: geolocationEntitySOVFilter,
  Trend: geolocationEntityTrendFilter,
  Tonality: geolocationEntityTonalityFilter,
}
const geolocationPublicationFilterObj = {
  SOV: geolocationPublicationSOVFilter,
  Trend: geolocationPublicationTrendFilter,
  Tonality: geolocationPublicationTonalityFilter,
}
const geolocationKeywordFilterObj = {
  SOV: geolocationKeywordSOVFilter,
  Trend: geolocationKeywordTrendFilter,
  Tonality: geolocationKeywordTonalityFilter,
}
const publicationEntityFilterObj = {
  SOV: publicationEntitySOVFilter,
  Trend: publicationEntityTrendFilter,
  Tonality: publicationEntityTonalityFilter,
}
const publicationJournalistFilterObj = {
  SOV: publicationJournalistSOVFilter,
  Trend: publicationJournalistTrendFilter,
  Tonality: publicationJournalistTonalityFilter,
}
const publicationKeywordFilterObj = {
  SOV: publicationKeywordSOVFilter,
  Trend: publicationKeywordTrendFilter,
  Tonality: publicationKeywordTonalityFilter,
}
const spokespersonFilterObj = {
  SOV: spokespersonSOVFilter,
  Trend: spokespersonTrendFilter,
}
const visibilityFilterObj = {
  SOV: visibilitySOVFilter,
}

//sov widget list
export const sovWidgetList = [
  //entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "SOV Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sovEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "SOV Entity (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Entity (Print & Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovEntityFilterObj,
  },
  //publication level
  {
    level: PUBLICATION,
    type: V_PRINT,
    name: "SOV Publication (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sovPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_ONLINE,
    name: "SOV Publication (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sovPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Publication (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sovPublicationFilterObj,
  },
  //city level
  {
    level: CITY,
    type: V_PRINT,
    name: "SOV City (Print)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovCityFilterObj,
  },
  //journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "SOV Journalist (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sovJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "SOV Journalist (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovJournalistFilterObj,
  },
  //keyword level
  {
    level: KEYWORD,
    type: V_PRINT,
    name: "SOV Keyword (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sovKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_ONLINE,
    name: "SOV Keyword (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Keyword (Print & Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: sovKeywordFilterObj,
  },

];


const geolocationNewEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.GeolocationNewEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.GeolocationNewEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.GeolocationNewEntitySOVCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.GeolocationNewEntitySOVMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.GeolocationNewEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const geolocationNewEntityFilterObj = {
  SOV: geolocationNewEntitySOVFilter,
}

//geolocation widget list
export const geoLocationWidgetList = [

  //new entity with all edition
  {
    level: 'NENTITY',
    type: V_PRINT,
    name: "Geolocation All Editon",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationNewEntityFilterObj,
  },
  // {
  //   level: 'NENTITY',
  //   type: V_ONLINE,
  //   name: "Geolocation  All Editon",
  //   graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
  //   filterOption: geolocationNewEntityFilterObj,
  // },
  //entity level
  //zone
  {
    level: ENTITY,
    type: V_PRINT,
    name: "Geolocation Zonal Spread",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Geolocation Zonal Spread ",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationEntityFilterObj,
  },
  //online = city
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "Geolocation Zonal Spread Index",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationEntityFilterObj,
  },
  //publication level
  //zone
  {
    level: PUBLICATION,
    type: V_PRINT,
    name: "Geolocation Zone Wise Top Publication",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationPublicationFilterObj,
  },
  //keyword level
  //zone
  {
    level: KEYWORD,
    type: V_PRINT,
    name: "Geolocation Zone Wise SOV Index",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: geolocationKeywordFilterObj,
  },
]

//thematic// entity
const thematicNewEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.ThematicNewEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.ThematicNewEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.ThematicNewEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.ThematicNewEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.ThematicNewEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.ThematicNewEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const thematicNewEntityFilterObj = {
  SOV: thematicNewEntitySOVFilter,
}

//thematic widget list
export const taWidgetList = [

  //entity level
  {
    level: 'NENTITY',
    type: V_PRINT,
    name: "Thematic Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicNewEntityFilterObj,
  },
  {
    level: 'NENTITY',
    type: V_ONLINE,
    name: "Thematic Entity (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicNewEntityFilterObj,
  },
  //entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "Thematic Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: thematicEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "Thematic Entity (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: thematicEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Thematic Entity (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicNewEntityFilterObj,
  },
  //publication level
  {
    level: PUBLICATION,
    type: V_PRINT,
    name: "Thematic Publication (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_ONLINE,
    name: "Thematic Publication (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_PRINT_AND_ONLINE,
    name: "Thematic Publication (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicPublicationFilterObj,
  },
  //city level
  {
    level: CITY,
    type: V_PRINT,
    name: "Thematic City (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicCityFilterObj,
  },
  {
    level: CITY,
    type: V_PRINT_AND_ONLINE,
    name: "Thematic City (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicCityFilterObj,
  },
  //journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "Thematic Journalist (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "Thematic Journalist (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: thematicJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "Thematic Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: thematicJournalistFilterObj,
  },
  //keyword level
  {
    level: KEYWORD,
    type: V_PRINT,
    name: "Thematic Keyword (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: thematicKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_ONLINE,
    name: "Thematic Keyword (Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: thematicKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_PRINT_AND_ONLINE,
    name: "Thematic Keyword (Print & Online)",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: thematicKeywordFilterObj,
  },
];





//keyword publication sov filter

const keywordPublicationSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordPublicationSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordPublicationSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordPublicationSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordPublicationSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordPublicationSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordPublicationSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// keyword publication trend filter
const keywordPublicationTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordPublicationTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordPublicationTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordPublicationTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordPublicationTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordPublicationTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordPublicationTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// keyword publication tonality
const keywordPublicationTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordPublicationTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordPublicationTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordPublicationTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordPublicationTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordPublicationTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordPublicationTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const keywordPublicationFilterObj = {
  SOV: keywordPublicationSOVFilter,
  Trend: keywordPublicationTrendFilter,
  Tonality: keywordPublicationTonalityFilter,
}



//keyword journalist sov filter

const keywordJournalistSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordJournalistSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordJournalistSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordJournalistSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordJournalistSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordJournalistSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordJournalistSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// keyword journalist trend filter
const keywordJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// keyword journalist tonality
const keywordJournalistTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordJournalistTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordJournalistTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordJournalistTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordJournalistTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordJournalistTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordJournalistTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const keywordJournalistFilterObj = {
  SOV: keywordJournalistSOVFilter,
  Trend: keywordJournalistTrendFilter,
  Tonality: keywordJournalistTonalityFilter,
}




//keyword City sov filter

const keywordCitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordCitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordCitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },

  {
    label: "CCM",
    value: REPORT_TYPES.KeywordCitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordCitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordCitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// keyword city trend filter
const keywordCityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordCityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordCityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },

  {
    label: "CCM",
    value: REPORT_TYPES.KeywordCityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordCityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordCityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// keyword city tonality
const keywordCityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordCityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordCityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordCityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordCityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordCityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const keywordCityFilterObj = {
  SOV: keywordCitySOVFilter,
  Trend: keywordCityTrendFilter,
  Tonality: keywordCityTonalityFilter,
}


//keyword spokesperson sov filter

const keywordSpokespersonSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordSpokespersonSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordSpokespersonSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordSpokespersonSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordSpokespersonSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordSpokespersonSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordSpokespersonSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// keyword spokesperson trend filter
const keywordSpokespersonTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordSpokespersonTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordSpokespersonTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordSpokespersonTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordSpokespersonTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordSpokespersonTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordSpokespersonTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// keyword spokesperson tonality
const keywordSpokespersonTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordSpokespersonTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordSpokespersonTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordSpokespersonTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordSpokespersonTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordSpokespersonTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordSpokespersonTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const keywordSpokespersonFilterObj = {
  SOV: keywordSpokespersonSOVFilter,
  Trend: keywordSpokespersonTrendFilter,
  Tonality: keywordSpokespersonTonalityFilter,
}



//keyword Entity sov filter

const keywordEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// keyword Entity trend filter
const keywordEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// keyword Entity tonality
const keywordEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.KeywordEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.KeywordEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.KeywordEntityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.KeywordEntityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.KeywordEntityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.KeywordEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const keywordEntityFilterObj = {
  SOV: keywordEntitySOVFilter,
  Trend: keywordEntityTrendFilter,
  Tonality: keywordEntityTonalityFilter,
}

//keyword widget list
export const keywordWidgetList = [

  //Entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "Keyword Entity (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "Keyword Entity (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Keyword Entity (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordEntityFilterObj,
  },

  //publication level
  {
    level: PUBLICATION,
    type: V_PRINT,
    name: "Keyword Publication (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_ONLINE,
    name: "Keyword Publication (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_PRINT_AND_ONLINE,
    name: "Keyword Publication (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordPublicationFilterObj,
  },

  //Journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "Keyword Journalist (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "Keyword Journalist (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordJournalistFilterObj,
  },

  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "Keyword Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordJournalistFilterObj,
  },
  // //City level

  {
    level: CITY,
    type: V_PRINT,
    name: "Keyword City (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordCityFilterObj,
  },
  {
    level: CITY,
    type: V_PRINT_AND_ONLINE,
    name: "Keyword City (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordCityFilterObj,
  },

  //Spokesperson level
  {
    level: SPOKESPERSON,
    type: V_PRINT,
    name: "Keyword Spokesperson (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordSpokespersonFilterObj,
  },
  {
    level: SPOKESPERSON,
    type: V_ONLINE,
    name: "Keyword Spokesperson (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: keywordSpokespersonFilterObj,
  },
  {
    level: SPOKESPERSON,
    type: V_PRINT_AND_ONLINE,
    name: "Keyword Spokesperson (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: keywordSpokespersonFilterObj,
  },


];



//sentimetn widget list
export const tonalityWidgetList = [
  //entity level
  {
    type: V_PRINT,
    name: "SENTIMENT BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentFilterObj,
    // tonalityFilter,
  },

  {
    type: V_PRINT,
    name: "Sentiment (Print)",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: sentimentFilterObj,
    // sentimentTableFilter,
  },
  //publication level
  {
    type: V_ONLINE,
    name: "SENTIMENT BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentFilterObj,
    // tonalityFilter,
  },

  {
    type: V_ONLINE,
    name: "Sentiment (Online)",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: sentimentFilterObj,
    // sentimentTableFilter,
  },
  //journalist level
  {
    type: V_PRINT,
    name: "SENTIMENT BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentFilterObj,
    // sentimentGenreFilter,
  },

  //city level

  //keyword level

];
const publicationNewEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.PublicationNewEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.PublicationNewEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.PublicationNewEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.PublicationNewEntitySOVCCM,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.PublicationNewEntitySOVMAV,
    vertical: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.PublicationNewEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const publicationNewEntityFilterObj = {
  SOV: publicationNewEntitySOVFilter
}
//publication widget list
export const publicationWidgetList = [

  //new level 
  {
    level: 'NENTITY',
    type: V_PRINT,
    name: "Publication Genre under Publication Analysis (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationNewEntityFilterObj,
  },
  // {
  //   level: 'NENTITY',
  //   type: V_ONLINE,
  //   name: "Publication Genre under Publication Analysis (Online))",
  //   graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
  //   filterOption: publicationNewEntityFilterObj,
  // },

  //entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "Publication Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "Publication Entity (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: publicationEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Publication Entity (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationEntityFilterObj,
  },
  //keyword level
  {
    level: KEYWORD,
    type: V_PRINT,
    name: "Publication Keyword (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_ONLINE,
    name: "Publication Keyword (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: publicationKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_PRINT_AND_ONLINE,
    name: "Publication Keyword (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationKeywordFilterObj,
  },
  //journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "Publication Journalist (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "Publication Journalist (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: publicationJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "Publication Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: publicationJournalistFilterObj,
  },
];




// sentiment trend filter
const sentimentEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment sov filter

const sentimentEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

// sentiment Journalist trend filter
const sentimentJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment Journalist sov filter

const sentimentJournalistSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentJournalistSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentJournalistSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentJournalistSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentJournalistSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentJournalistSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentJournalistSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

// sentiment publication trend
const sentimentPublicationTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentPublicationTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentPublicationTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentPublicationTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentPublicationTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentPublicationTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentPublicationTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment publicaiton sov filter
const sentimentPublicationSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentPublicationSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentPublicationSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentPublicationSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentPublicationSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentPublicationSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentPublicationSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// sentiment City trend filter
const sentimentCityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentCityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentCityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.SentimentCityTrendWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentCityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentCityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentCityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment City sov filter

const sentimentCitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentCitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentCitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  // {
  //   label: "Word count",
  //   value: REPORT_TYPES.SentimentCitySOVWordCount,
  //   vertical: [V_ONLINE],
  // },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentCitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentCitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentCitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// sentiment Keyword trend filter
const sentimentKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentKeywordTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//sentiment Keyword sov filter

const sentimentKeywordSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentKeywordSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentKeywordSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentKeywordSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentKeywordSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentKeywordSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentKeywordSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];




// spokesperson trend filter
const spokespersonEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//spokesperson sov filter

const spokespersonEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

// spokesperson Journalist trend filter
const spokespersonJournalistTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonJournalistTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonJournalistTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonJournalistTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonJournalistTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonJournalistTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonJournalistTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//spokesperson Journalist sov filter

const spokespersonJournalistSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonJournalistSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonJournalistSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonJournalistSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonJournalistSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonJournalistSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonJournalistSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

// spokesperson Topic trend
const spokespersonTopicTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonTopicTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonTopicTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonTopicTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonTopicTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonTopicTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonTopicTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//spokesperson topic sov filter
const spokespersonTopicSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonTopicSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonTopicSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonTopicSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonTopicSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonTopicSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonTopicSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];



// spokesperson Profile trend filter
const spokespersonProfileTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonProfileTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonProfileTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonProfileTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonProfileTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonProfileTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonProfileTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//spokesperson Profile sov filter

const spokespersonProfileSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SpokespersonProfileSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SpokespersonProfileSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SpokespersonProfileSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SpokespersonProfileSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SpokespersonProfileSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SpokespersonProfileSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//put all the filter options in the lists above


// const tonalityFilter = [
//   {
//     label: "Index",
//     value: REPORT_TYPES.SentimentReportIndex,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "Number of article",
//     value: REPORT_TYPES.SentimentReportArticle,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
// ];

// const sentimentGenreFilter = [
//   {
//     label: "Index",
//     value: REPORT_TYPES.SentimentGenreIndex,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "Number of article",
//     value: REPORT_TYPES.SentimentGenreArticle,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
// ];

// const tonalityTrendFilter = [
//   {
//     label: "Number of article",
//     value: REPORT_TYPES.TonalityNAOTrend,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "CCM",
//     value: REPORT_TYPES.TonalityCCMTrend,
//     vertical: [V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "MAV",
//     value: REPORT_TYPES.TonalityMAVTrend,
//     vertical: [V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "Word Count",
//     value: REPORT_TYPES.TonalityWCTrend,
//     vertical: [V_ONLINE, V_PRINT_AND_ONLINE],
//   },
// ];

// export const sentimentTableFilter = [


//   {
//     label: "Index",
//     value: REPORT_TYPES.SENTIMENTTABLEINDEX,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
//   {
//     label: "Number of article",
//     value: REPORT_TYPES.SENTIMENTTABLEARTICLE,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   },
// ];

// export const sovTableFilter = [
//   {
//     label: "Snapshot",
//     value: REPORT_TYPES.SNAPSHOT,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   }
// ];

// export const sovStoryTableFilter = [
//   {
//     label: "StoryTable",
//     value: REPORT_TYPES.STORYTABLE,
//     vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
//   }
// ];

//new framework takes object as filterOption in widget lists.
//these are the new objects passed into filteroptions for respective widget lists
// const sovEntityFilterObj = {
//   Ranking: sovEntityRankingFilter,
//   Trend: sovEntityTrendFilter,
//   Tonality: sovEntityTonalityFilter,
// }

// const sovJournalistFilterObj = {
//   Ranking: sovJournalistRankingFilter,
//   Trend: sovJournalistTrendFilter,
//   Tonality: sovJournalistTonalityFilter,
// }

// const sovCityFilterObj = {
//   Ranking: sovCityRankingFilter,
//   Trend: sovCityTrendFilter,
//   Tonality: sovCityTonalityFilter,
// }

// const sovPublicationFilterObj = {
//   Ranking: sovPublicationRankingFilter,
//   Trend: sovPublicationTrendFilter,
//   Tonality: sovPublicationTonalityFilter,
// }

// const sovKeywordFilterObj = {
//   Ranking: sovKeywordRankingFilter,
//   Trend: sovKeywordTrendFilter,
//   Tonality: sovKeywordTonalityFilter,
// }
// //thematic filter objects
// const thematicEntityFilterObj = {
//   SOV: thematicEntitySOVFilter,
//   Trend: thematicEntityTrendFilter,
//   Tonality: thematicEntityTonalityFilter,
// }

// const thematicJournalistFilterObj = {
//   SOV: thematicJournalistSOVFilter,
//   Trend: thematicJournalistTrendFilter,
//   Tonality: thematicJournalistTonalityFilter,
// }

// const thematicCityFilterObj = {
//   SOV: thematicCitySOVFilter,
//   Trend: thematicCityTrendFilter,
//   Tonality: thematicCityTonalityFilter,
// }

// const thematicPublicationFilterObj = {
//   SOV: thematicPublicationSOVFilter,
//   Trend: thematicPublicationTrendFilter,
//   Tonality: thematicPublicationTonalityFilter,
// }

// const thematicKeywordFilterObj = {
//   SOV: thematicKeywordSOVFilter,
//   Trend: thematicKeywordTrendFilter,
//   Tonality: thematicKeywordTonalityFilter,
// }



const sentimentEntityFilterObj = {
  Trend: sentimentEntityTrendFilter,
  SOV: sentimentEntitySOVFilter,
}

const sentimentPublicationFilterObj = {
  Trend: sentimentPublicationTrendFilter,
  SOV: sentimentPublicationSOVFilter,
}

const sentimentJournalistFilterObj = {
  Trend: sentimentJournalistTrendFilter,
  SOV: sentimentJournalistSOVFilter,
}
const sentimentCityFilterObj = {
  Trend: sentimentCityTrendFilter,
  SOV: sentimentCitySOVFilter,
}
const sentimentKeywordFilterObj = {
  Trend: sentimentKeywordTrendFilter,
  SOV: sentimentKeywordSOVFilter,
}

const spokespersonEntityFilterObj = {
  SOV: spokespersonEntitySOVFilter,
  Trend: spokespersonEntityTrendFilter,
}

const spokespersonTopicFilterObj = {
  SOV: spokespersonTopicSOVFilter,
  Trend: spokespersonTopicTrendFilter,
}

const spokespersonJournalistFilterObj = {
  SOV: spokespersonJournalistSOVFilter,
  Trend: spokespersonJournalistTrendFilter,
}

const spokespersonProfileFilterObj = {
  SOV: spokespersonProfileSOVFilter,
  Trend: spokespersonProfileTrendFilter,
}

//spokesperson widget list


export const spokesWidgetList = [
  //entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "Spokesperson Entity (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "Spokesperson Entity (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Spokesperson Entity (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonEntityFilterObj,
  },


  //topic level
  {
    level: TOPIC,
    type: V_PRINT,
    name: "Spokesperson Topic (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonTopicFilterObj,
  },
  {
    level: TOPIC,
    type: V_ONLINE,
    name: "Spokesperson Topic (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonTopicFilterObj,
  },
  {
    level: TOPIC,
    type: V_PRINT_AND_ONLINE,
    name: "Spokesperson Topic (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonTopicFilterObj,
  },

  // //profile level

  {
    level: PROFILING,
    type: V_PRINT,
    name: "Spokesperson Profile (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonProfileFilterObj,
  },
  {
    level: PROFILING,
    type: V_ONLINE,
    name: "Spokesperson Profile (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonProfileFilterObj,
  },
  {
    level: PROFILING,
    type: V_PRINT_AND_ONLINE,
    name: "Spokesperson Profile (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonProfileFilterObj,
  },

  //journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "Spokesperson Journalist (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "Spokesperson Journalist (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: spokespersonJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "Spokesperson Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: spokespersonJournalistFilterObj,
  },


];


const sentimentNewEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.SentimentNewEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.SentimentNewEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.SentimentNewEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.SentimentNewEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.SentimentNewEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.SentimentNewEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
const sentimentNewEntityFilterObj = {
  SOV: sentimentNewEntitySOVFilter,
}


//sentimetn widget list
export const sentimentWidgetList = [

  //new entitiy all editon all sentiment

  {
    level: 'NENTITY',
    type: V_PRINT,
    name: "Sentiment Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sentimentNewEntityFilterObj,
  },
  {
    level: 'NENTITY',
    type: V_ONLINE,
    name: "Sentiment Entity (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: sentimentNewEntityFilterObj,
  },
  // //entity level
  // {
  //   level: ENTITY,
  //   type: V_PRINT,
  //   name: "Sentiment Entity (Print)",
  //   graph_type: GRAPH_TYPES.BAR_VERTICAL,
  //   filterOption: sentimentEntityFilterObj,
  // },
  // {
  //   level: ENTITY,
  //   type: V_ONLINE,
  //   name: "Sentiment Entity (Online)",
  //   graph_type: GRAPH_TYPES.LINE,
  //   filterOption: sentimentEntityFilterObj,
  // },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "Sentiment Entity (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentEntityFilterObj,
  },

  //publication level
  {
    level: PUBLICATION,
    type: V_PRINT,
    name: "Sentiment Publication (Print)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentPublicationFilterObj,
  },
  {
    level: PUBLICATION,
    type: V_ONLINE,
    name: "Sentiment Publication (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sentimentPublicationFilterObj,
  },

  {
    level: PUBLICATION,
    type: V_PRINT_AND_ONLINE,
    name: "Sentiment Publication (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentPublicationFilterObj,
  },


  //journalist level
  {
    level: JOURNALIST,
    type: V_PRINT,
    name: "Sentiment Journalist (Print)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_ONLINE,
    name: "Sentiment Journalist (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sentimentJournalistFilterObj,
  },
  {
    level: JOURNALIST,
    type: V_PRINT_AND_ONLINE,
    name: "Sentiment Journalist (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentJournalistFilterObj,
  },

  //city level
  //city level
  {
    level: CITY,
    type: V_PRINT,
    name: "Sentiment City (Print)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sentimentCityFilterObj,
  },
  {
    level: CITY,
    type: V_PRINT_AND_ONLINE,
    name: "Sentiment City (Print & Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sentimentCityFilterObj,
  },
  //keyword level

  {
    level: KEYWORD,
    type: V_PRINT,
    name: "Sentiment Keyword (Print)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_ONLINE,
    name: "Sentiment Keyword (Online)",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: sentimentKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_PRINT_AND_ONLINE,
    name: "Sentiment Keyword (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: sentimentKeywordFilterObj,
  },

];


//journalist entity sov filter

const journalistEntitySOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistEntitySOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistEntitySOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistEntitySOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistEntitySOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistEntitySOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistEntitySOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// journalist entity trend filter
const journalistEntityTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistEntityTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistEntityTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistEntityTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistEntityTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistEntityTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistEntityTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
// journalist entity tonality
const journalistEntityTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistEntityTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistEntityTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistEntityTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistEntityTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistEntityTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistEntityTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


const journalistEntityFilterObj = {
  SOV: journalistEntitySOVFilter,
  Trend: journalistEntityTrendFilter,
  Tonality: journalistEntityTonalityFilter,
}




//journalist keyword sov filter

const journalistKeywordSOVFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistKeywordSOVNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistKeywordSOVIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistKeywordSOVWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistKeywordSOVCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistKeywordSOVMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistKeywordSOVReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];


// journalist keyword trend filter
const journalistKeywordTrendFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistKeywordTrendNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistKeywordTrendIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistKeywordTrendWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistKeywordTrendCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistKeywordTrendMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistKeywordTrendReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];
//journalist keyword tonality 
const journalistKeywordTonalityFilter = [

  {
    label: "Number of article",
    value: REPORT_TYPES.JournalistKeywordTonalityNOA,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Index",
    value: REPORT_TYPES.JournalistKeywordTonalityIndex,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Word count",
    value: REPORT_TYPES.JournalistKeywordTonalityWordCount,
    vertical: [V_ONLINE],
  },
  {
    label: "CCM",
    value: REPORT_TYPES.JournalistKeywordTonalityCCM,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "MAV",
    value: REPORT_TYPES.JournalistKeywordTonalityMAV,
    vertical: [V_PRINT, V_PRINT_AND_ONLINE],
  },
  {
    label: "Reach '000",
    value: REPORT_TYPES.JournalistKeywordTonalityReach,
    vertical: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
  },
];

const journalistKeywordFilterObj = {
  SOV: journalistKeywordSOVFilter,
  Trend: journalistKeywordTrendFilter,
  Tonality: journalistKeywordTonalityFilter,
}

//journalist widget list
export const journalistWidgetList = [


  //entity level
  {
    level: ENTITY,
    type: V_PRINT,
    name: "SOV Entity (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_ONLINE,
    name: "SOV Entity (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistEntityFilterObj,
  },
  {
    level: ENTITY,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Entity (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistEntityFilterObj,
  },

  //keyword level
  {
    level: KEYWORD,
    type: V_PRINT,
    name: "SOV Keyword (Print)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_ONLINE,
    name: "SOV Keyword (Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistKeywordFilterObj,
  },
  {
    level: KEYWORD,
    type: V_PRINT_AND_ONLINE,
    name: "SOV Keyword (Print & Online)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: journalistKeywordFilterObj,
  },

];

//DESIRED OUTPUT 
//BY QUALITATIVE SETTINGS
// const reportCategoryList = [
//   {
//     id: SOV,
//     label: "Share of Voice",
//     component: ShareOfVoice,
//     widgetList: sovWidgetList,
//   },
//   {
//     id: THEMATIC_ANALYSIS,
//     label: "Thematic Analysis",
//     component: ThematicAnalysis,
//     widgetList: taWidgetList,
//   },
//   {
//     id: GEOLOCATION,
//     label: "Geographical Spread",
//     component: Geo,
//     widgetList: geoLocationWidgetList,
//   },
//   // {
//   //   id: PUBLICATION,
//   //   label: "Publication",
//   //   component: Publication,
//   //   widgetList: publicationWidgetList,
//   // },
//   {
//     id: JOURNALIST,
//     label: "Journalist",
//     component: Journalist,
//     widgetList: journalistWidgetList,
//   },
//   {
//     id: SPOKESPERSON,
//     label: "Spokesperson​",
//     component: Spokesperson,
//     widgetList: spokesWidgetList,
//   },
//   {
//     id: SENTIMENT,
//     label: "Sentiment",
//     component: Sentiments,
//     widgetList: sentimentWidgetList,
//   },

//   // {
//   //   id: KEYWORD_CLOUD,
//   //   label: "Keyword Analysis",
//   //   component: KeywordCloud,
//   //   widgetList: keywordWidgetList,
//   // },
// ];

export const getWidgetsBySettings = (qualitativeSettings, typeSettings) => {
  const settings = qualitativeSettings.settings;
  const isPrint = typeSettings.isPrint === true ? 2 : 0;
  const isOnline = typeSettings.isOnline === true ? 1 : 0;
  const isPrintOnline = typeSettings.isPrintAndOnline === true ? -1 : 0;
  const reportCategoryById = {
    1: { id: REPORT_CATEGORIES.SOV, component: ShareOfVoice, widgetList: sovWidgetList, embededEnabled: true },
    2: { id: REPORT_CATEGORIES.THEMATIC_ANALYSIS, component: ThematicAnalysis, widgetList: taWidgetList, embededEnabled: true },
    3: { id: REPORT_CATEGORIES.GEOLOCATION, component: Geo, widgetList: geoLocationWidgetList, embededEnabled: true },
    4: { id: REPORT_CATEGORIES.JOURNALIST, component: Journalist, widgetList: journalistWidgetList, embededEnabled: true },
    5: { id: REPORT_CATEGORIES.SPOKESPERSON, component: Spokesperson, widgetList: spokesWidgetList, embededEnabled: true },
    6: { id: REPORT_CATEGORIES.SENTIMENT, component: Sentiments, widgetList: sentimentWidgetList, embededEnabled: true },
    7: { id: REPORT_CATEGORIES.KEYWORD_CLOUD, component: KeywordCloud, widgetList: keywordWidgetList, embededEnabled: true },
    8: { id: REPORT_CATEGORIES.PUBLICATION, component: Publication, widgetList: publicationWidgetList, embededEnabled: true },
  };
  const reportCategoryList = [];
  settings.forEach((graph_type) => {
    const categoryObject = {};
    categoryObject.id = reportCategoryById[graph_type.graph_id].id;
    categoryObject.label = graph_type.graph_type;
    categoryObject.component = reportCategoryById[graph_type.graph_id].component;
    categoryObject.embededEnabled = reportCategoryById[graph_type.graph_id].embededEnabled;
    const defaultWidgetLists = reportCategoryById[graph_type.graph_id].widgetList;
    const defaultWidgetList = defaultWidgetLists.filter(e => e.type === isOnline || e.type === isPrint || e.type === isPrintOnline)
    const newWidgetList = [];
    defaultWidgetList.forEach((widget) => {
      if (graph_type.entity_level && widget.level === ENTITY) {
        newWidgetList.push(widget);
      }
      else if (graph_type.publication_level && widget.level === PUBLICATION) {
        newWidgetList.push(widget);
      }
      else if (graph_type.journalist_level && widget.level === JOURNALIST) {
        newWidgetList.push(widget);
      }
      else if (graph_type.city_level && widget.level === CITY) {
        newWidgetList.push(widget);
      }
      else if (graph_type.keyword_level && widget.level === KEYWORD) {
        newWidgetList.push(widget);
      }
      else if (graph_type.spokesperson_level && widget.level === SPOKESPERSON) {
        newWidgetList.push(widget);
      }
      else if (graph_type.profiling_level && widget.level === PROFILING) {
        newWidgetList.push(widget);
      }
      else if (graph_type.visibility_level && widget.level === VISIBILITY) {
        newWidgetList.push(widget);
      }
      else if (graph_type.topic_level && widget.level === TOPIC) {
        newWidgetList.push(widget);
      }
      else if (widget.level === 'NENTITY') {
        newWidgetList.push(widget);
      }
    });
    categoryObject.widgetList = newWidgetList;
    reportCategoryList.push(categoryObject);
  });
  return reportCategoryList;
}
